import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';

import { NutritionMealTabComponent } from './nutrition-meal-tab.component';

@NgModule({
  declarations: [NutritionMealTabComponent],
  imports: [CommonModule, FormsModule, NgxBootstrapIconsModule, TooltipModule],
  exports: [NutritionMealTabComponent],
})
export class NutritionMealTabModule {}
